module.exports = __webpack_public_path__ + "img/match.668c1be3.svg";